import type { FaireProductEntity } from "../../entity_types/product";

export const p_muspmvda28: FaireProductEntity = {
  token: "p_muspmvda28",
  type: "product",
  name: "Oatmeal + Milk & Honey Tallow Soap",
  brandName: "Von Wieting Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/320e5be61cfce744450101e948511708ce5469015d9d17250d55821a28f78352.jpeg",
  priceDollars: 3.75,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/cf1d3f5c125589cef1deb64ce344736dc01223d0fa2e8960c473c21969e32253.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
